import React from 'react';
import { DashboardContent } from '@/layouts/dashboard';
import { Sidebar } from './Sidebar';
import { TokensSection } from './sections/Tokens';
import { ButtonsSection } from './sections/Buttons';
import { FormsSection } from './sections/Forms';
import { CardsSection } from './sections/Cards';
import { CalendarsSection } from './sections/Calendars';
import { ProgressSection } from './sections/Progress';
import { FeedbackSection } from './sections/Feedback';
import { GamificationSection } from './sections/Gamification';
import { NavigationSection } from './sections/Navigation';
import { ModalsSection } from './sections/Modals';
import { IconsSection } from './sections/Icons';
import { DashboardSection } from './sections/Dashboard';
import { ReportsSection } from './sections/Reports';
import { ProfileSection } from './sections/Profile';
import { ChatSection } from './sections/Chat';
import { TablesSection } from './sections/Tables';

const SECTIONS = [
  { id: 'tokens', title: 'Tokens', Component: TokensSection },
  { id: 'buttons', title: 'Buttons & Badges', Component: ButtonsSection },
  { id: 'forms', title: 'Forms & Inputs', Component: FormsSection },
  { id: 'cards', title: 'Cards', Component: CardsSection },
  { id: 'tables', title: 'Tables', Component: TablesSection },
  { id: 'dashboard', title: 'Dashboard', Component: DashboardSection },
  { id: 'reports', title: 'Reports', Component: ReportsSection },
  { id: 'calendars', title: 'Calendars', Component: CalendarsSection },
  { id: 'progress', title: 'Progress & KPIs', Component: ProgressSection },
  { id: 'feedback', title: 'Feedback & States', Component: FeedbackSection },
  { id: 'gamification', title: 'Gamification', Component: GamificationSection },
  { id: 'navigation', title: 'Navigation', Component: NavigationSection },
  { id: 'modals', title: 'Modals & Overlays', Component: ModalsSection },
  { id: 'icons', title: 'Icons & Avatars', Component: IconsSection },
  { id: 'profile', title: 'Profile', Component: ProfileSection },
  { id: 'chat', title: 'Chat', Component: ChatSection }
];

export default function DesignSystem() {
  return (
    <DashboardContent variant="plain">
      {/* Header */}
      <div className="mb-8">
        <h1 className="text-3xl font-extrabold text-primary">Design System</h1>
        <p className="mt-2 text-neutral-dark">Referencia visual completa dos tokens e componentes do Estudologia AVA</p>
      </div>

      {/* Layout: Sidebar + Content */}
      <div className="flex gap-8">
        <Sidebar sections={SECTIONS} />

        <main className="min-w-0 flex-1">
          {SECTIONS.map(({ id, Component }) => (
            <Component key={id} />
          ))}
        </main>
      </div>
    </DashboardContent>
  );
}
